import * as yup from "yup";

export const confirmarPagamentoSchema = yup.object().shape({
  dataPagamento: yup.string().required("Data obrigatória"),
  arquivo: yup
    .mixed()
    .test("file-selected", "Selecione um arquivo", (value) => {
      return value instanceof File && value.size > 0;
    })
    .required("Selecione um arquivo")
    .nonNullable(),
});
